module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1511-60bca36abbd5a524d215bbe0d377349a.png";